import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PeriodBar } from "@/components/perf/common";
import PerfCard from "@/components/perf/PerfCard";
import Coach from "@/components/perf/Coach";
import Plans from "@/components/perf/Plans";
import Learning from "@/components/perf/Learning";

function useHistory(userId) {
  const [h, setH] = useState(null);
  useEffect(() => { api.get("/perf/history", { params: { user_id: userId || undefined } }).then((r) => setH(r.data)).catch(() => setH([])); }, [userId]);
  return h;
}

function History({ userId }) {
  const h = useHistory(userId);
  if (!h) return <p className="mu">Loading…</p>;
  if (!h.length) return <p className="mu" data-testid="history-empty">No closed periods yet. The System Admin closes a period to save its results permanently.</p>;
  return h.map((s, i) => { const prev = h[i + 1]; return (<div key={s.from} className="vr" style={{ cursor: "default" }} data-testid={`history-${s.from}`}><div style={{ flex: 1 }}><b>{s.from} to {s.to}</b><small>{s.role?.label} · KPI {s.config ? `v${s.config.version}` : "none"}{prev && prev.config?.version !== s.config?.version ? " · KPI set changed from the previous period" : ""}</small></div><span>{s.score ?? "N/A"}{prev && s.score != null && prev.score != null ? ` (${s.score - prev.score >= 0 ? "+" : ""}${s.score - prev.score})` : ""}</span></div>); });
}

const TABS = [["card", "Scorecard"], ["coach", "Coach"], ["plans", "Improvement plans"], ["learn", "Learning"], ["hist", "History"]];

export default function PerfView({ userId, initial }) {
  const [P, setP] = useState(initial || { p: "month", start: "", end: "" });
  const [t, setT] = useState("card");
  return (<div data-testid="perf-view">
    <div className="seg2 ptabs" style={{ marginBottom: 10 }} data-testid="perf-tabs">{TABS.map(([k, l]) => <span key={k} className={t === k ? "on" : ""} onClick={() => setT(k)} data-testid={`perf-tab-${k}`}>{l}</span>)}</div>
    {["card", "coach"].includes(t) && <PeriodBar P={P} setP={setP} />}
    {t === "card" && <PerfCard P={P} userId={userId} />}{t === "coach" && <Coach P={P} userId={userId} />}{t === "plans" && <Plans userId={userId} />}{t === "learn" && <Learning />}{t === "hist" && <History userId={userId} />}
  </div>);
}
